import type { ActivitySummary, LoadMethod } from '@painpal/contracts';
import { Ban, HeartPulse, Timer, Zap, type LucideIcon } from 'lucide-react';
import { noLoadLabel } from '../lib/format';
import styles from './LoadMethodBadge.module.css';

const METHODS: Record<LoadMethod, { Icon: LucideIcon; label: string }> = {
  power: { Icon: Zap, label: 'LOAD FROM POWER' },
  pace: { Icon: Timer, label: 'LOAD FROM PACE' },
  hr: { Icon: HeartPulse, label: 'LOAD FROM HR' },
};

export function LoadMethodBadge({ activity }: { activity: ActivitySummary }) {
  if (activity.status !== 'processed') return null;
  if (activity.load === null || activity.loadMethod === null) {
    return <span className={styles.badge} data-method="none"><Ban size={10} aria-hidden="true" />{noLoadLabel(activity)}</span>;
  }
  const { Icon, label } = METHODS[activity.loadMethod];
  return <span className={styles.badge} data-method={activity.loadMethod}><Icon size={10} aria-hidden="true" />{label}</span>;
}
